import { DjangoEmployer, Employer, parseEmployer } from '../employer';
import { DjangoUser } from '../user';
import { DjangoInvoice, Invoice } from './invoice.model';


export class EmployerInvoice extends Invoice {
  employer: Employer;
  closeBy: string;
  installmentsCount?: number;
  paycheckAdvancesCount?: number;
  rescissionsCount?: number;
  totalAmount?: number;
  amountStatusTotalCount?: number;
  amountStatusPartialCount?: number;
  amountStatusNoPayCount?: number;

  constructor(data: string | EmployerInvoice | DjangoEmployerInvoice = {}) {
    super(data);

    if (typeof data !== 'string') {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export function parseEmployerInvoice(val) {
  if (val) {
    return new EmployerInvoice(val);
  } else {
    return undefined;
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoEmployerInvoice extends DjangoInvoice {
  employer?: string | DjangoEmployer;
  installments_count?: number;
  paycheck_advances_count?: number;
  rescissions_count?: number;
  total_amount?: number;
  amount_status_total_count?: number;
  amount_status_partial_count?: number;
  amount_status_no_pay_count?: number;
  closed_by?: string | DjangoUser;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: EmployerInvoice,
  data: EmployerInvoice | DjangoEmployerInvoice,
) {
  const jsData = bindDjangoPropsToJs(data);
  instance.employer = parseEmployer(data.employer);
  instance.installmentsCount = jsData.installmentsCount;
  instance.paycheckAdvancesCount = jsData.paycheckAdvancesCount;
  instance.rescissionsCount = jsData.rescissionsCount;
  instance.totalAmount = jsData.totalAmount;
  instance.amountStatusTotalCount = jsData.amountStatusTotalCount;
  instance.amountStatusPartialCount = jsData.amountStatusPartialCount;
  instance.amountStatusNoPayCount = jsData.amountStatusNoPayCount;
  instance.closeBy = jsData.closeBy;
}

function bindDjangoPropsToJs(data: EmployerInvoice | DjangoEmployerInvoice) {
  const djangoData = data as DjangoEmployerInvoice;
  const jsData = data as EmployerInvoice;
  return {
    ...data,
    installmentsCount: djangoData.installments_count || jsData.installmentsCount,
    paycheckAdvancesCount: djangoData.paycheck_advances_count || jsData.paycheckAdvancesCount,
    rescissionsCount: djangoData.rescissions_count || jsData.rescissionsCount,
    totalAmount: djangoData.total_amount || jsData.totalAmount,
    amountStatusTotalCount: djangoData.amount_status_total_count || jsData.amountStatusTotalCount,
    amountStatusPartialCount: djangoData.amount_status_partial_count || jsData.amountStatusPartialCount,
    amountStatusNoPayCount: djangoData.amount_status_no_pay_count || jsData.amountStatusNoPayCount,
    closeBy: djangoData.closed_by || jsData.closeBy,
  } as EmployerInvoice;
}
